import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FaPlus, FaYoutube, FaUpload, FaVideo } from "react-icons/fa";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import Modal from "./Modal";
import MiniLoader from "./MiniLoader";
import StoreReelVideoRecorder from "./StoreReelVideoRecorder";
import * as actions_media from "../redux/actions/mediaActions";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/ModalStoreAddReel.css";

const MODES = {
  YOUTUBE: "youtube",
  UPLOAD: "upload",
  RECORD: "record",
};

const MAX_VIDEO_BYTES = 100 * 1024 * 1024;
const VIDEO_ACCEPT = "video/mp4,video/webm,video/quicktime,video/x-m4v,video/avi,video/x-msvideo";

function isYoutubeUrl(url) {
  return /(?:youtube\.com|youtu\.be)/i.test(String(url || "").trim());
}

function isVideoFile(file) {
  if (!file) return false;
  return String(file.type || "").startsWith("video/");
}

class ModalStoreAddReel extends Component {
  state = {
    title: "",
    mode: MODES.YOUTUBE,
    youtubeUrl: "",
    videoFile: null,
    videoPreviewUrl: "",
    saving: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.resetForm();
    }
  }

  componentWillUnmount() {
    this.revokePreviewUrl();
  }

  resetForm = () => {
    this.revokePreviewUrl();
    this.setState({
      title: "",
      mode: MODES.YOUTUBE,
      youtubeUrl: "",
      videoFile: null,
      videoPreviewUrl: "",
      saving: false,
    });
  };

  getDefaultAdId = () => {
    const firstAd = this.props.storeAdList[0];
    return firstAd ? String(firstAd.Id) : "";
  };

  revokePreviewUrl = () => {
    if (this.state.videoPreviewUrl) {
      URL.revokeObjectURL(this.state.videoPreviewUrl);
    }
  };

  onChangeMode = (mode) => {
    this.revokePreviewUrl();
    this.setState({
      mode,
      youtubeUrl: "",
      videoFile: null,
      videoPreviewUrl: "",
    });
  };

  onChangeTitle = (event) => {
    this.setState({ title: event.target.value });
  };

  onChangeUrl = (event) => {
    this.setState({ youtubeUrl: event.target.value });
  };

  onChangeVideoFile = (event) => {
    const file = event.target.files[0];
    event.target.value = "";

    if (!file) return;

    if (!isVideoFile(file)) {
      alertify.warning(I18n.t("store_reels_invalid_video"));
      return;
    }

    if (file.size > MAX_VIDEO_BYTES) {
      alertify.warning(I18n.t("store_reels_video_too_large"));
      return;
    }

    this.revokePreviewUrl();
    this.setState({
      videoFile: file,
      videoPreviewUrl: URL.createObjectURL(file),
    });
  };

  onRecordedVideo = (file) => {
    this.revokePreviewUrl();
    this.setState({
      videoFile: file,
      videoPreviewUrl: file ? URL.createObjectURL(file) : "",
    });
  };

  buildFormData = () => {
    const { mode, youtubeUrl, videoFile, title } = this.state;
    const adId = this.getDefaultAdId();
    const params = new FormData();
    params.append("goder_id", adId);
    params.append("id", this.props.user_id);
    params.append("media_id", "");
    params.append("title", title.trim());

    if (mode === MODES.YOUTUBE) {
      params.append("link", youtubeUrl.trim());
      return params;
    }

    if (videoFile) {
      params.append("video", videoFile, videoFile.name);
    }

    return params;
  };

  validateForm = () => {
    const { mode, youtubeUrl, videoFile, title } = this.state;

    if (!this.getDefaultAdId()) {
      alertify.warning(I18n.t("store_reels_no_ads"));
      return false;
    }

    if (!String(title || "").trim()) {
      alertify.warning(I18n.t("store_reels_title_required"));
      return false;
    }

    if (mode === MODES.YOUTUBE) {
      if (!isYoutubeUrl(youtubeUrl)) {
        alertify.warning(I18n.t("store_reels_invalid_youtube"));
        return false;
      }
      return true;
    }

    if (!videoFile || !isVideoFile(videoFile)) {
      alertify.warning(I18n.t("store_reels_invalid_video"));
      return false;
    }

    if (videoFile.size > MAX_VIDEO_BYTES) {
      alertify.warning(I18n.t("store_reels_video_too_large"));
      return false;
    }

    return true;
  };

  onSubmit = async () => {
    if (!this.validateForm()) return;

    this.setState({ saving: true });

    try {
      await this.props.AddMedia(this.props.token, this.buildFormData());
      alertify.success(I18n.t("saved_succesfull"));
      this.props.onSuccess();
      this.props.onClose();
    } catch (error) {
      alertify.warning(I18n.t(error || "try_later"));
    } finally {
      this.setState({ saving: false });
    }
  };

  renderModeTabs() {
    const tabs = [
      { id: MODES.YOUTUBE, label: "store_reels_mode_youtube", icon: FaYoutube },
      { id: MODES.UPLOAD, label: "store_reels_mode_upload", icon: FaUpload },
      { id: MODES.RECORD, label: "store_reels_mode_record", icon: FaVideo },
    ];

    return (
      <div className="store-add-reel-modal__tabs" role="tablist">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = this.state.mode === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`store-add-reel-modal__tab${isActive ? " is-active" : ""}`}
              onClick={() => this.onChangeMode(tab.id)}
            >
              <Icon />
              <Translate value={tab.label} />
            </button>
          );
        })}
      </div>
    );
  }

  renderVideoSource() {
    const { mode, youtubeUrl, videoPreviewUrl } = this.state;

    if (mode === MODES.YOUTUBE) {
      return (
        <React.Fragment>
          <label className="store-add-reel-modal__label" htmlFor="store_reel_url">
            <Translate value="store_reels_youtube_url" />
          </label>
          <div className="store-add-reel-modal__url-row">
            <span className="store-add-reel-modal__url-icon" aria-hidden="true">
              <FaYoutube />
            </span>
            <input
              id="store_reel_url"
              type="url"
              className="store-add-reel-modal__input"
              value={youtubeUrl}
              placeholder="https://www.youtube.com/watch?v=..."
              onChange={this.onChangeUrl}
            />
          </div>
        </React.Fragment>
      );
    }

    if (mode === MODES.UPLOAD) {
      return (
        <React.Fragment>
          <label className="store-add-reel-modal__label" htmlFor="store_reel_video">
            <Translate value="store_reels_upload_video" />
          </label>
          <div className="store-add-reel-modal__upload">
            <input
              id="store_reel_video"
              type="file"
              className="store-add-reel-modal__file-input"
              accept={VIDEO_ACCEPT}
              onChange={this.onChangeVideoFile}
            />
            <label htmlFor="store_reel_video" className="store-add-reel-modal__upload-btn">
              <FaUpload />
              <Translate value="store_reels_mode_upload" />
            </label>
            {videoPreviewUrl && (
              <video
                src={videoPreviewUrl}
                className="store-add-reel-modal__video-preview"
                controls
                playsInline
              />
            )}
          </div>
        </React.Fragment>
      );
    }

    return (
      <StoreReelVideoRecorder
        active={this.props.isOpen && mode === MODES.RECORD}
        onVideoChange={this.onRecordedVideo}
      />
    );
  }

  render() {
    const { isOpen, onClose, storeAdList, loadingAds } = this.props;
    const { saving } = this.state;
    const hasPublishedAd = storeAdList.length > 0;

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={<Translate value="store_reels_add" />}
      >
        <div className="store-add-reel-modal">
          <p className="store-add-reel-modal__hint">
            <Translate value="store_reels_add_hint" />
          </p>

          {loadingAds ? (
            <div className="store-add-reel-modal__loading">
              <MiniLoader />
            </div>
          ) : !hasPublishedAd ? (
            <div className="store-add-reel-modal__empty">
              <p>
                <Translate value="store_reels_no_ads" />
              </p>
              <Link to="/panel/ads" className="store-add-reel-modal__link">
                <Translate value="ads" />
              </Link>
            </div>
          ) : (
            <React.Fragment>
              <label className="store-add-reel-modal__label" htmlFor="store_reel_title">
                <Translate value="store_reels_title" />
              </label>
              <input
                id="store_reel_title"
                type="text"
                className="store-add-reel-modal__input"
                value={this.state.title}
                placeholder={I18n.t("store_reels_title_placeholder")}
                maxLength={120}
                onChange={this.onChangeTitle}
              />
              {this.renderModeTabs()}
              {this.renderVideoSource()}
            </React.Fragment>
          )}

          <div className="store-add-reel-modal__footer">
            <button
              type="button"
              className="store-add-reel-modal__btn store-add-reel-modal__btn--secondary"
              onClick={onClose}
              disabled={saving}
            >
              <Translate value="close" />
            </button>
            {hasPublishedAd && (
              <button
                type="button"
                className="store-add-reel-modal__btn store-add-reel-modal__btn--primary"
                onClick={this.onSubmit}
                disabled={saving}
              >
                <FaPlus />
                <Translate value="store_reels_add" />
              </button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    storeAdList: reducer.marketstoreAdList.list,
    loadingAds: reducer.marketstoreAdList.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AddMedia: (token, params) => dispatch(actions_media.newItem({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalStoreAddReel);
